import axios from 'axios';
import promise from 'promise';

const initBearer = 'Bearer ';

const urlOfSystem = [
    { regEx: /.*\/campana/, headerValue: 'GetCampana', headerToken: true },
    { regEx: /.*\/fecha/, headerValue: 'GetCampana', headerToken: true },
    { regEx: /.*\/credito\/indicadorcurse/, headerValue: 'GetCampana', headerToken: true },
    { regEx: /.*\/credito\/simular/, headerValue: 'PostSimular', headerToken: true },
    { regEx: /.*\/credito\/solicitar/, headerValue: 'PostSolicitar', headerToken: true },
    { regEx: /.*\/credito\/muestra/, headerValue: 'PostSolicitar', headerToken: true },
    { regEx: /.*\/socio/, headerValue: 'GetSocio', headerToken: true },
    { regEx: /.*\/enfermedades/, headerValue: 'GetEnfermedades', headerToken: true },
    { regEx: /.*\/credito\/formalizar/, headerValue: 'GetFormalizar', headerToken: true },
    { regEx: /.*\/documentos/, headerValue: 'GetDocumentos', headerToken: true },
    { regEx: /.*\/documento\/obtener/, headerValue: 'GetDocumento', headerToken: true },
    { regEx: /.*\/documento\/agregar/, headerValue: 'GetDocumento', headerToken: true },
    { regEx: /.*\/documento\/enviar/, headerValue: 'GetDocumento', headerToken: true },
    { regEx: /.*\/tarjetacoordenada\/obtenerdesafio/, headerValue: 'GetDesafio', headerToken: true },
    { regEx: /.*\/credito\/cursar/, headerValue: 'PostCursar', headerToken: true },
    { regEx: /.*\/tarjetacoordenada\/validardesafio/, headerValue: 'PostValidar', headerToken: true },
    { regEx: /.*\/tercerfactor\/validar/, headerValue: 'PostValidar', headerToken: true },
    { regEx: /.*\/tercerfactor\/enviar/, headerValue: 'GetValidar', headerToken: true },
    { regEx: /.*\/mdp/, headerValue: 'PostCursar', headerToken: true },
    { regEx: /.*\/token\/refrescar/, headerValue: 'PostRefresh', headerToken: true },
    { regEx: /.*\/rechazos/, headerValue: 'GetMotivos', headerToken: true },
    { regEx: /.*\/abandono/, headerValue: 'PutAbandono', headerToken: true },
    { regEx: /.*\/seguros/, headerValue: 'GetSeguros', headerToken: true }

];

const validaUrlSegura = (url) => {
    let necesitaToken = false;
    urlOfSystem.forEach((registro) => {
        if (registro.regEx.test(url) && registro.headerToken) {
            necesitaToken = true;
        }
    });
    return necesitaToken;
};

const obtenerCustomHeader = (url) => {
    let customHeader;
    urlOfSystem.forEach((registro) => {
        if (registro.regEx.test(url)) {
            customHeader = registro.headerValue;
        }
    });
    return customHeader;
};

const HttpInterceptor = (token, idflujo) => {
    axios.interceptors.request.use(
        (config) => {
            const configClone = Object.assign({}, config);
            if (validaUrlSegura(config.url)) {
                configClone.headers.Authorization = `${initBearer + token}`;
                configClone.headers.idFlujo = idflujo;
                

            }
            const customHeader = obtenerCustomHeader(config.url);
            if (customHeader !== undefined) {
                configClone.headers.method = customHeader;
                
            }
            return configClone;
        },
        (error) => {
            return promise.reject(error);
        }
    );
};

export default HttpInterceptor;  
